import { isDev } from "../config";

const BASE_URL_EXCHANGE = isDev
  ? "https://api.metamui.money/devnet"
  : "https://api.metablock.exchange/did";
export const RESTORE_VC = `${BASE_URL_EXCHANGE}/handleSsidRestore`;
